<template>
    <div id="help_videos" class="container-fluid">
        <div class="modal fade" id="view_help_video" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-xxl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ view_video_title }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body text-center">
                        <video id="video" :src="view_video_url" class="w-100" controls autoplay>
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>
        </div>

        <v-client-table :data="tableData" :columns="columns" :options="options">
            <div slot="actions" slot-scope="props" class="text-right">
                <button type="button" @click="viewVideo(props.row)" class="btn btn-info reverse" data-toggle="modal" data-target="#view_help_video">View Video</button>
            </div>
        </v-client-table>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();

            $(document).off('show.bs.modal', '#view_help_video').on('show.bs.modal', '#view_help_video', function() {
                $('#video').get(0).load();
            });
        },

        data() {
            return {
                view_video_url:   null,
                view_video_title: '',

                columns: ['title', 'description', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        title:       'Title',
                        description: 'Description',
                        actions:     ''
                    },
                    sortable: ['title', 'description'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} videos|{count} videos|One video',
                        filter: '',
                        filterPlaceholder: 'Search videos...',
                        noResults: 'No matching videos'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.get('/api/help/videos').then(response => {
                    this.tableData = response.data;
                });
            },

            viewVideo(video) {
                this.view_video_url   = video.url;
                this.view_video_title = video.title;
            }
        }
    }
</script>